import React from 'react';
import t from 'prop-types';
import Pestana from './pestana';

var PestanaAvance = function PestanaAvance(_ref) {
  var boton = _ref.boton,
      onBoton = _ref.onBoton;
  var clases = ['siguienteNavegarVentana'];

  if (boton.anulado) {
    clases.push('desactivado');
  }

  return React.createElement(Pestana, {
    boton: boton,
    onBoton: onBoton,
    clases: clases
  });
};

PestanaAvance.propTypes = process.env.NODE_ENV !== "production" ? {
  boton: t.object,
  onBoton: t.func
} : {};
export default PestanaAvance;